import React, { useState, useRef, useCallback } from 'react';

const ACCEPTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
const MAX_SIZE = 2 * 1024 * 1024;

const ImageDropzone = ({ preview, onFileSelect, hint = 'Ideal size: 800x400px' }) => {
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const processFile = useCallback((file) => {
    if (!file) return;
    if (!ACCEPTED_TYPES.includes(file.type)) {
      alert('Please upload a JPG, PNG, GIF, or WebP image.');
      return;
    }
    if (file.size > MAX_SIZE) {
      alert('Image must be smaller than 2MB.');
      return;
    }
    onFileSelect(file);
  }, [onFileSelect]);

  const handleDragOver = (e) => { e.preventDefault(); setDragOver(true); };
  const handleDragLeave = () => setDragOver(false);
  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    processFile(e.dataTransfer.files?.[0]);
  };
  const handleFileInput = (e) => {
    processFile(e.target.files?.[0]);
    e.target.value = '';
  };

  return (
    <div
      className={'border rounded p-3 text-center ' + (dragOver ? 'border-success' : '')}
      style={{ cursor: 'pointer', background: dragOver ? 'rgba(65,146,78,0.05)' : '#fafafa', borderStyle: 'dashed' }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={() => fileInputRef.current?.click()}
    >
      {preview ? (
        <div>
          <img
            src={preview}
            alt="Preview"
            style={{ maxHeight: '140px', maxWidth: '100%', objectFit: 'contain', borderRadius: '6px' }}
          />
          <div className="small text-muted mt-2">Click or drag to replace</div>
        </div>
      ) : (
        <div className="py-3">
          <i className="zmdi zmdi-cloud-upload text-muted" style={{ fontSize: '32px' }} />
          <div className="text-muted mt-2">Click to upload or drag and drop</div>
          <div className="small text-muted">{hint}</div>
        </div>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="d-none"
        onChange={handleFileInput}
      />
    </div>
  );
};

export default ImageDropzone;
